import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import { Text } from '~/shared/ui/Text'

import { CHIP_HEIGHT } from './config'
import type { ChipProps } from './types'

import styles from './Chip.module.scss'

/**
 * Чип-ответ/чип-выбора, спека 01 §21-22. Приоритет состояний: isDisabled >
 * isSelected > variant (ANSWER невыбранный — акцентный, SELECT невыбранный — нейтральный).
 */
export const Chip = memo(function Chip(props: ChipProps) {
  const { isSelected, size = 'M', variant = 'ANSWER', text, isDisabled = false, onPress } = props

  const { pressProps, isPressed } = usePress({ onPress, isDisabled })

  return (
    <button
      className={cn(
        styles.root,
        styles[`variant_${variant}`],
        isSelected && styles.isSelected,
        isDisabled && styles.isDisabled,
      )}
      type='button'
      data-pressed={isPressed}
      aria-pressed={isSelected}
      aria-disabled={isDisabled || undefined}
      style={{ height: CHIP_HEIGHT[size] }}
      {...pressProps}
    >
      {/* Два слоя в одной ячейке грида: невидимый всегда набран самым жирным начертанием
          чипа и задаёт ширину, видимый лежит поверх и меняет только вес и цвет. Так ширина
          чипа не зависит от состояния — иначе при выборе (400/600 → 700) чип раздаётся и
          весь ряд переезжает вбок. Приём тот же, что в WheelPicker: слои совпадают по
          метрикам, различаются только оформлением. */}
      <span className={styles.label}>
        <span className={styles.reserve} aria-hidden='true'>
          <Text variant='BODY_S' color='INHERIT'>
            {text}
          </Text>
        </span>
        <span className={styles.value}>
          <Text variant='BODY_S' color='INHERIT'>
            {text}
          </Text>
        </span>
      </span>
    </button>
  )
})
